module.exports = __webpack_public_path__ + "img/icon-zzzc.add4ae89.png";